
export const mailbox = {
    
    methods: {
        //TODO：获取收信箱信息
        async getMsgData(req){
            let { pageNum, pageSize ,type } = req;
            let res = await this.$http.get("/tenant/in/box/list",{
                type: type ?? null,
                pageNum, 
                pageSize
            });
            return res;
      
        },
          //TODO：获取发信箱信息
          async getSendMsgData(req){
            let { pageNum, pageSize } = req;
            let res = await this.$http.get("/tenant/out/box/list",{
                pageNum, 
                pageSize
            });
            return res;
      
        },
        //TODO: 修改记录已读状态
        async updateMsgStatus(id){
            let res = await this.$http.put(`/tenant/in/box/read/${id}`);
            let msgUnread = await this.getMsgUnreadCount();//获取未读消息
            this.$store.state.MessageCount = msgUnread.data;
            return res;
        },
        //TODO：删除收信箱记录
        async delGetMsgData(id){
            let res = await this.$http.delete(`/tenant/in/box/${id}`);
            return res;
        },
        //TODO：删除发信箱记录
        async delSendMsgData(id){
            let res = await this.$http.delete(`/tenant/out/box/${id}`);
            return res;
        },
        //TODO: 获取收信箱未读数量
        async getMsgUnreadCount(){
            let res = await this.$http.get(`/tenant/in/box/not/read/num`);
            return res;
        }
    },
}